import { render } from "./ResourceCardFull.vue?vue&type=template&id=6e7b587a"
import script from "./ResourceCardFull.vue?vue&type=script&lang=js"
export * from "./ResourceCardFull.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__